<jqxWindow #uploadImageWind [width]="400" [height]="150" [isModal]="true" [position]="'center'"
  [showCloseButton]="true" [resizable]="false" [autoOpen]="false" [theme]="environment.tema"
  [title]="translate('Subida_imagen')" (onClose)="onCloseWindowImage()">
  <div class="bg-transparent">
    <mcg-loader [message]="translate('Guardando')" [showLoader]="isLoading()"></mcg-loader>

    <div class="row overflow-hidden bg-transparent">
      <span class="full-width full-height">
        <div class="clear-both mt-1">
          {{ translate("Selecciona_imagen") }}
        </div>
        <input [(ngModel)]="inputFile" type="file" accept="image/png, image/jpeg" (change)="onSelectImage($event)">
      </span>
    </div>

    <jqxButton class="float-right mb-1" [width]="80" [height]="30" (onClick)="uploadImage()">
      {{translate('Guardar')}}
    </jqxButton>
  </div>
</jqxWindow>

<div class="row principal-container">
  <div class="container center-container">
    <div class="row imagen-principal">
      <div *ngIf="selectedImg" class="full-height">
        <img #imgPrincipalContainer src="data:image/png;base64,{{selectedImg?.Imagen ? selectedImg?.Imagen : selectedImg?.imagen}}">
      </div>
    </div>

    <div class="row mt-1">
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/previous.png"' [imgPosition]="'center'"  [disabled]="imagenes?.length <= 1 && imagenes?.length <= 1"
        (onClick)="changeImage('previous')">
      </jqxButton>
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/next.png"' [imgPosition]="'center'" [disabled]="imagenes?.length <= 1 && imagenes?.length <= 1"
        (onClick)="changeImage('next')">
      </jqxButton>
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/rotate-left.png"' [imgPosition]="'center'" [disabled]="selectedImg === null"
        (onClick)="rotate('left')">
      </jqxButton>
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/rotate-right.png"' [imgPosition]="'center'" [disabled]="selectedImg === null"
        (onClick)="rotate('right')">
      </jqxButton>
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/refresh.png"' [imgPosition]="'center'" [disabled]="selectedImg === null"
        (onClick)="rotate('180')">
      </jqxButton>
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/upload.png"' [imgPosition]="'center'" [disabled]="imagenes === null"
        (onClick)="openUploadImageWind()">
      </jqxButton>
      <jqxButton class="float-left" [width]="35" [height]="35" [imgHeight]="25" [imgWidth]="25"
        [imgSrc]='"/assets/images/borrar.png"' [imgPosition]="'center'" [disabled]="selectedImg === null"
        (onClick)="openDeleteImageWind()">
      </jqxButton>
    </div>
  </div>

  <div class="container slider-images">
    <div *ngFor="let img of imagenes; let i = index">
      <div *ngIf="img.id === selectedImg.id" class="image-container image-active" (click)="setImgPrincipal(img)">
        <div class="bg-white full-height full-width">
          <img #imgPrincipalContainer src="data:image/png;base64,{{img.Imagen ? img?.Imagen : img?.imagen}}">
        </div>
      </div>
      <div *ngIf="img.id !== selectedImg.id" class="image-container" (click)="setImgPrincipal(img)">
        <div class="bg-white full-height full-width">
          <img #imgPrincipalContainer src="data:image/png;base64,{{img.Imagen ? img?.Imagen : img?.imagen}}">
        </div>
      </div>
  </div>
</div>
